// Client Portal — module-level toast so portals don't prop-drill a handler.
// ToastHost mounts once at the App root; showToast() is called from anywhere.

import { useState, useEffect } from "react";
import { CheckCircle, AlertCircle, X } from "lucide-react";

let _pushToast = null;

export const showToast = (message, type = "error") => {
  if (_pushToast) _pushToast({ id: Date.now() + Math.random(), message, type });
};

export const ToastHost = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    _pushToast = (t) => {
      setToasts((prev) => [...prev.slice(-3), t]);
      setTimeout(
        () => setToasts((prev) => prev.filter((x) => x.id !== t.id)),
        6000,
      );
    };
    return () => {
      _pushToast = null;
    };
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2 max-w-sm">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`flex items-start gap-2.5 px-4 py-3 rounded-lg shadow-lg border text-sm ${
            t.type === "success"
              ? "bg-green-50 border-green-200 text-green-800"
              : "bg-red-50 border-red-200 text-red-800"
          }`}
        >
          {t.type === "success" ? (
            <CheckCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
          ) : (
            <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
          )}
          <span className="flex-1">{t.message}</span>
          <button
            onClick={() =>
              setToasts((prev) => prev.filter((x) => x.id !== t.id))
            }
            className="flex-shrink-0 opacity-60 hover:opacity-100"
            aria-label="Dismiss notification"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
};
